/**
 * Preserves the `merchantSlug` route parameter when navigating from a page
 * that has the slug to a page that doesn't.
 *
 * This is useful for maintaining merchant context (e.g. /thomann/dashboard -> /thomann/login).
 * Can be explicitly disabled for a single navigation by adding the
 * `?preserveSlug=false` query parameter to the destination link.
 */
export default defineNuxtRouteMiddleware((to, from) => {
	// Opt-out mechanism to explicitly disable the slug preservation.
	if (to.query.preserveSlug === 'false') {
		return;
	}

	// Don't act if the destination route already has the slug.
	if ('merchantSlug' in to.params) {
		return;
	}

	// Don't act if there's no slug to preserve from the source route.
	if (!('merchantSlug' in from.params)) {
		return;
	}

	// Avoids running on page reloads or query changes on the same route.
	if (to.name === from.name) {
		return;
	}

	// @ts-expect-error, We only use this middleware where a merchant slug is either required or optional
	return navigateTo({ ...to, params: { merchantSlug: from.params.merchantSlug } });
});
